import { Link } from '@inertiajs/react';
import { ArrowLeft, ShieldCheck, Sparkles } from 'lucide-react';
import { motion } from 'motion/react';

export default function AuthSplitLayout({
    title = 'Welcome back',
    description = 'Continue your premium shopping experience.',
    aside,
    children,
}) {
    return (
        <main className="min-h-screen bg-background text-foreground lg:grid lg:grid-cols-[1.08fr_0.92fr]">
            <section className="relative hidden min-h-screen overflow-hidden bg-[#d80b67] lg:block">
                <img
                    src="https://images.unsplash.com/photo-1523398002811-999ca8dec234?auto=format&fit=crop&w=1800&q=90"
                    alt="Captex premium fashion collection"
                    className="absolute inset-0 size-full object-cover opacity-65"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-black/10" />
                <div className="relative flex min-h-screen flex-col justify-between p-10 text-white xl:p-16">
                    <Link
                        href="/"
                        className="inline-flex w-fit items-center gap-3 text-sm font-black uppercase tracking-[0.24em]"
                    >
                        <span className="flex size-11 items-center justify-center rounded-full border border-white/30 bg-white/10 backdrop-blur-xl">
                            CT
                        </span>
                        Captex
                    </Link>

                    <motion.div
                        initial={{ opacity: 0, y: 28 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.65 }}
                        className="max-w-xl pb-8"
                    >
                        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-2 text-[11px] font-black uppercase tracking-[0.22em] backdrop-blur-xl">
                            <Sparkles className="size-3.5" /> Members experience
                        </span>
                        <h1 className="mt-7 text-6xl font-black uppercase leading-[0.9] tracking-[-0.06em] xl:text-8xl">
                            {title}
                        </h1>
                        <p className="mt-6 max-w-md text-base leading-7 text-white/70 xl:text-lg">
                            {description}
                        </p>
                        {aside}
                    </motion.div>
                </div>
            </section>

            <section className="flex min-h-screen items-center justify-center px-4 py-8 sm:px-8 lg:px-12 xl:px-20">
                <motion.div
                    initial={{ opacity: 0, y: 22, scale: 0.985 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 0.5, ease: 'easeOut' }}
                    className="w-full max-w-xl rounded-[2rem] border border-rose-100 bg-[linear-gradient(180deg,rgba(255,255,255,0.96),rgba(255,247,250,0.92))] p-6 shadow-[0_30px_90px_rgba(245,27,117,0.12)] backdrop-blur-2xl sm:p-10 xl:p-12"
                >
                    <div className="mb-9 flex items-center justify-between">
                        <Link
                            href="/"
                            className="inline-flex items-center gap-2 text-xs font-black uppercase tracking-[0.16em] text-muted-foreground transition hover:text-foreground lg:hidden"
                        >
                            <ArrowLeft className="size-4" /> Store
                        </Link>
                        <span className="ml-auto inline-flex items-center gap-2 text-xs font-semibold text-muted-foreground">
                            <ShieldCheck className="size-4" /> Secure account
                        </span>
                    </div>
                    <div className="auth-luxury">{children}</div>
                </motion.div>
            </section>
        </main>
    );
}
